import Page from './layout/Page.vue'

export default {
  install(Vue) {
    Vue.component('Page', Page)
  }
}
